import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { adminClient } from "@/lib/api";

export const InstagramMedia = ({ media, alt = "Imported Instagram media", testId, className = "" }) => {
    const [src, setSrc] = useState("");
    const [failed, setFailed] = useState(false);
    useEffect(() => {
        let cancelled = false;
        let objectUrl;
        setSrc(""); setFailed(false);
        if (media?.url) adminClient().get(media.url.replace(/^\/api/, ""), { responseType: "blob" })
            .then(({ data }) => {
                if (cancelled) return;
                objectUrl = URL.createObjectURL(data);
                setSrc(objectUrl);
            }).catch(() => { if (!cancelled) setFailed(true); });
        return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
    }, [media?.url]);
    return src ? <img src={src} alt={alt} data-testid={testId} className={className} />
        : <div data-testid={testId} className={`flex items-center justify-center bg-zinc-900 text-zinc-500 ${className}`}>
            <ImageOff className="h-6 w-6" aria-label={failed ? "Image unavailable" : "No image loaded"} />
        </div>;
};